module.exports = __webpack_public_path__ + "img/HC1027-74.bf50e325.jpg";